import { render, staticRenderFns } from "./BackSvg.vue?vue&type=template&id=18484770&"
var script = {}
import style0 from "./BackSvg.vue?vue&type=style&index=0&id=18484770&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports